export default __webpack_public_path__ + "images/tr-2880fc8e0e28f4a11a8d5f7db508d4c6.svg";